import { DatepickerCalendarDayProps, DAY_TYPE } from '../../Datepicker.consts';
import { StyledTd } from '../../Datepicker.styles';
import { getDayType, isDayDisabled } from '../../Datepicker.utils';
import { useDatepickerStore } from '@/stores/DatepickerStore/DatepickerStore';

export const DatepickerSingle: React.FC<DatepickerCalendarDayProps> = ({
  day,
  className,
}: DatepickerCalendarDayProps) => {
  const { day: selectedDay, setDay, setDateByDayType, isCurrentDay } = useDatepickerStore();
  const isDisabled = isDayDisabled(className);
  const dayType = getDayType(className);

  const handleSelection = () => {
    if (isDisabled) {
      setDateByDayType(day, getDayType(className));
    } else if (selectedDay !== day || !selectedDay) {
      setDay(day);
    }
  };

  const isSelectedDay = () => {
    return dayType === DAY_TYPE.CURRENT_MONTH && day === selectedDay;
  };

  const getClassName = () => {
    const allClasses = `day ${className} ${isSelectedDay() ? 'single-day' : ''}`;

    if (isDisabled) {
      return allClasses;
    }

    return `${allClasses}${isCurrentDay(day) ? ' current-day' : ''}`;
  };

  return (
    <StyledTd onClick={handleSelection} className={getClassName()}>
      {day}
    </StyledTd>
  );
};
